import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import * as $ from 'jquery';
import './form-item-generic-form.component.scss';
var FormItemGenericForm = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemGenericForm, _super);
    function FormItemGenericForm(element) {
        var _this = _super.call(this, element) || this;
        _this.valuesJson = {};
        return _this;
    }
    FormItemGenericForm.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.selectTitle = this.element.querySelector('.js-title');
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
        this.buttonSubmitNew = Array.from(this.element.querySelectorAll('.js-submit__generic-form'));
        this.radioFeedbackType = Array.from(this.element.querySelectorAll('.js-feedback-type__radio'));
        if (this.element.getAttribute('data-formname')) {
            this.formValueName = this.element.getAttribute('data-formname');
            var parent_1 = this.element.closest('.form-container');
            if (this.element.closest('.form-container')) {
                var parent_2 = this.element.closest('.form-container');
                if (parent_2.querySelector('.apply-now__title--module-title')) {
                    var title = parent_2.querySelector('.apply-now__title--module-title');
                    title.innerHTML = this.formValueName;
                }
            }
        }
        if (this.element.getAttribute('data-recipient')) {
            this.formValueRecipient = this.element.getAttribute('data-recipient');
            if (this.element.querySelector('input[name=recipient]')) {
                this.formInputRecipient = this.element.querySelector('input[name=recipient]');
                this.formInputRecipient.value = this.formValueRecipient;
            }
        }
        if (this.element.getAttribute('data-email')) {
            this.formValueEmail = this.element.getAttribute('data-email');
            if (this.element.querySelector('input[name=email]')) {
                this.formInputEmail = this.element.querySelector('input[name=email]');
                this.formInputEmail.value = this.formValueEmail;
            }
        }
        if (this.element.getAttribute('data-subject')) {
            this.formValueSubject = this.element.getAttribute('data-subject');
            if (this.element.querySelector('input[name=subject]')) {
                this.formInputSubject = this.element.querySelector('input[name=subject]');
                this.formInputSubject.value = this.formValueSubject;
            }
        }
        if (this.element.getAttribute('data-frmcontainer')) {
            this.formValueFrmcontainer = this.element.getAttribute('data-frmcontainer');
            this.form.setAttribute('data-frmcontainer', this.formValueFrmcontainer);
        }
        if (this.element.getAttribute('data-successmessage')) {
            this.formValueSuccessMessage = this.element.getAttribute('data-successmessage');
            if (this.element.querySelector('.js-apply-now-success-message')) {
                this.formInputSuccess = this.element.querySelector('.js-apply-now-success-message');
                this.formInputSuccess.innerHTML = "<h4 class=\"title title--module-sub-title text-center enquiry__title\">" + this.formValueSuccessMessage + "</h4><div class=\"form__success--image\"> <i data-component=\"icon\" data-icon=\"form-complete\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon \"><!--?xml version=\"1.0\" encoding=\"UTF-8\"?--><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"127px\" height=\"118px\" viewBox=\"0 0 127 118\" version=\"1.1\"><title>Group 4</title> <g id=\"Success-Messages\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Success-message-\" transform=\"translate(-686.000000, -882.000000)\"><g id=\"Group-4\" transform=\"translate(687.000000, 883.000000)\"><g id=\"Group\"><path d=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293\" id=\"Fill-5\" fill=\"#C4E4FF\"></path><path d=\"M106.4448,38.5349293 L106.4448,89.4262698 C106.4448,96.1257337 100.549937,101.6064 93.3440832,101.6064 L13.1007168,101.6064 C5.89617554,101.6064 0,96.1257337 0,89.4262698 L0,38.5349293 C0,37.5842148 0.160100916,36.6335004 0.478990445,35.7311716 C0.585286955,35.39901 0.691583465,35.1139265 0.851684381,34.8275352 C0.957980891,34.5424516 1.11808181,34.3057538 1.27687042,34.0206702 C3.08784799,31.0743707 6.59956973,29.0304 10.6440863,29.0304 L95.8007137,29.0304 C99.8452303,29.0304 103.358264,31.0743707 105.16793,34.0206702 C105.326718,34.3057538 105.486819,34.5424516 105.593116,34.8275352 C105.753217,35.1139265 105.859513,35.39901 105.96581,35.7311716 C106.284699,36.6335004 106.4448,37.5842148 106.4448,38.5349293 Z\" id=\"Stroke-7\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path><path d=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948\" id=\"Fill-9\" fill=\"#9DD2FF\"></path><path d=\"M0,40.0640948 C0,36.7352797 1.49077574,33.3516528 4.52350703,31.0428721 L4.84239656,30.8289724 L45.658944,2.38030335 C50.2113217,-0.793434449 56.2334783,-0.793434449 60.785856,2.38030335 L101.601091,30.8289724 L101.921293,31.0428721 C104.954024,33.3516528 106.4448,36.7352797 106.4448,40.0640948 C106.4448,41.1376043 106.284699,42.2124506 105.96581,43.2324851 C105.859513,43.6081466 105.753217,43.9303331 105.593116,44.2525196 C105.486819,44.5747062 105.326718,44.8434177 105.16793,45.1656043 C103.356952,48.4944194 99.8452303,50.8032 95.8007137,50.8032 L10.6440863,50.8032 C6.59956973,50.8032 3.08653569,48.4944194 1.27687042,45.1656043 C1.11808181,44.8434177 0.957980891,44.5747062 0.851684381,44.2525196 C0.691583465,43.9303331 0.585286955,43.6081466 0.478990445,43.2324851 C0.160100916,42.2124506 0,41.1376043 0,40.0640948 Z\" id=\"Stroke-11\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linejoin=\"round\"></path><path d=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\" id=\"Fill-13\" fill=\"#FFFFFF\"></path><path d=\"M91.9296,50.8032 L91.9296,8.98629601 C91.9296,8.03092904 90.7188472,7.2576 89.223443,7.2576 L14.802157,7.2576 C13.3067528,7.2576 12.096,8.03092904 12.096,8.98629601 L12.096,50.8032 L91.9296,50.8032 Z\" id=\"Stroke-15\" stroke=\"#0033AA\" stroke-width=\"1.93536\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><polygon id=\"Fill-17\" fill=\"#C4E4FF\" points=\"21.7728 19.3536 84.672 19.3536 84.672 16.9344 21.7728 16.9344\"></polygon><polygon id=\"Fill-19\" fill=\"#C4E4FF\" points=\"21.7728 24.192 67.7376 24.192 67.7376 21.7728 21.7728 21.7728\"></polygon><polygon id=\"Fill-20\" fill=\"#C4E4FF\" points=\"21.7728 36.288 84.672 36.288 84.672 33.8688 21.7728 33.8688\"></polygon><polygon id=\"Fill-21\" fill=\"#C4E4FF\" points=\"21.7728 43.5456 67.7376 43.5456 67.7376 41.1264 21.7728 41.1264\"></polygon></g><g id=\"Group-5-Copy\" transform=\"translate(67.200000, 58.800000)\"><path d=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544\" id=\"Fill-22\" fill=\"#4AA740\"></path><path d=\"M57.257088,28.628544 C57.257088,44.43936 44.43936,57.257088 28.628544,57.257088 C12.817728,57.257088 5.72981662e-14,44.43936 5.72981662e-14,28.628544 C5.72981662e-14,12.817728 12.817728,5.72981662e-14 28.628544,5.72981662e-14 C44.43936,5.72981662e-14 57.257088,12.817728 57.257088,28.628544 Z\" id=\"Stroke-23\" stroke=\"#0033AA\" stroke-width=\"1.344\"></path><polyline id=\"Stroke-24\" stroke=\"#FFFFFF\" stroke-width=\"2.688\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"15.067584 30.1353024 24.108672 39.1763904 42.189504 18.0809664\"></polyline></g></g></g></g></svg></i></div>";
            }
        }
        if (this.element.querySelector('.js-submit__generic-form--recaptcha')) {
            this.buttonSubmitRecaptcha = this.element.querySelector('.js-submit__generic-form--recaptcha');
        }
    };
    FormItemGenericForm.prototype.bindEvents = function () {
        var _this = this;
        if (this.radioFeedbackType) {
            this.radioFeedbackType.map(function (item) { return item.addEventListener('click', function (event) {
                var element = event.target;
                if (element.value == "compliment") {
                    _this.formValueFeedbackType = 'compliment';
                }
                else {
                    _this.formValueFeedbackType = 'complaint';
                }
            }); });
        }
        if (this.selectTitle) {
            this.selectTitle.addEventListener('change', function (event) {
                var element = event.target;
                _this.addMoreTitle(element);
            });
        }
        if (this.buttonSubmit) {
            this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
                var formFields = _this.form.querySelectorAll('input, select, textarea');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    if (_this.valuesJson.feedbackType !== "") {
                        _this.actionForm(_this.form, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
                    }
                    else {
                        _this.radioFeedbackType.map(function (item, index) {
                            var parent = item.closest('.form__group');
                            parent.classList.add('form__group--error');
                        });
                    }
                }
            }); });
        }
        if (this.buttonSubmitNew) {
            this.buttonSubmitNew.map(function (item) { return item.addEventListener('click', function (event) {
                var formFields = _this.form.querySelectorAll('input, select, textarea');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    if (_this.valuesJson.feedbackType !== "") {
                        _this.actionFormNew(_this.form);
                    }
                    else {
                        _this.radioFeedbackType.map(function (item, index) {
                            var parent = item.closest('.form__group');
                            parent.classList.add('form__group--error');
                        });
                    }
                }
            }); });
        }
        if (this.buttonSubmitRecaptcha) {
            this.buttonSubmitRecaptcha.addEventListener('click', function (event) {
                var formFields = _this.form.querySelectorAll('input, select, textarea');
                var validation = _this.validationService.validateEnterprise(formFields);
                var formRecaptchaField = _this.form.querySelector('.form-item-generic-form__recaptcha');
                if (formRecaptchaField.querySelector('.form__group--error_message')) {
                    var errorMessage = formRecaptchaField.querySelector('.form__group--error_message');
                    formRecaptchaField.removeChild(errorMessage);
                }
                if (validation.valid) {
                    var recaptcha = _this.element.querySelector('textarea[name=g-recaptcha-response]');
                    if (recaptcha) {
                        if (recaptcha.value) {
                            if (_this.valuesJson.feedbackType !== "") {
                                _this.actionFormRecaptcha(_this.form);
                            }
                            else {
                                _this.radioFeedbackType.map(function (item, index) {
                                    var parent = item.closest('.form__group');
                                    parent.classList.add('form__group--error');
                                });
                            }
                        }
                        else {
                            var docfragment = document.createDocumentFragment();
                            docfragment.appendChild(document.createRange().createContextualFragment('<div class="form__group--error_message">Please click on the reCAPTCHA box</div>'));
                            formRecaptchaField.appendChild(docfragment);
                        }
                    }
                }
            });
        }
        $(document).on('click', '.js-apply-now-modal-open', function (event) {
            var element = event.target;
            var modal = $(element).attr('data-modal');
            if (modal) {
                _this.callmebackFormId = modal;
            }
        });
        // $(this.element).on('click', '.js-submit__generic-form', (event) => {
        // 	let element = undefined;
        // 	if(event.currentTarget){
        // 		element = event.currentTarget;
        // 	}else{
        // 		element = event.target;
        // 	}
        // 	let form: any = element.closest('form');
        // 	let formFields: any = form.querySelectorAll('input, select, textarea');
        // 	let validation: any = this.validationService.validateEnterprise(formFields);
        // 	if (validation.valid) {
        // 		if (this.valuesJson.feedbackType !== "") {
        // 			this.actionFormNew(form);
        // 		} else {
        // 			this.radioFeedbackType.map((item, index) => {
        // 				let parent = item.closest('.form__group');
        // 				parent.classList.add('form__group--error');
        // 			});
        // 		}
        // 	}
        // });
    };
    FormItemGenericForm.prototype.addMoreTitle = function (element) {
        if (element) {
            if (element.value == 'Other') {
                var parentParent = element.closest('.form__fields--container');
                var parent_3 = element.closest('.form__group');
                var newContainer = document.createElement('div');
                newContainer.classList.add('form__group');
                newContainer.classList.add('js-other-title-container');
                var newLabel = document.createElement('label');
                newLabel.classList.add('form__label');
                newLabel.innerHTML = 'Other Title';
                newContainer.appendChild(newLabel);
                var newInput = document.createElement('input');
                newInput.classList.add('js-other-title');
                newInput.classList.add('form__input');
                newInput.classList.add('form__input--required');
                newInput.setAttribute('placeholder', 'Enter your title');
                newInput.setAttribute('maxlength', '4');
                newInput.setAttribute('name', 'other-title');
                newContainer.appendChild(newInput);
                parentParent.insertBefore(newContainer, parent_3.nextSibling);
            }
            else {
                var parentParent = element.closest('.form__fields--container');
                var oldInput = this.element.querySelector('.js-other-title-container');
                if (oldInput) {
                    parentParent.removeChild(oldInput);
                }
            }
        }
    };
    FormItemGenericForm.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormItemGenericForm.prototype.actionForm = function (form, loader, thankyou) {
        // fields
        var recipient = this.form.querySelector('input[name=recipient]');
        var email = this.form.querySelector('input[name=email]');
        var subject = this.form.querySelector('input[name=subject]');
        var redirect = this.form.querySelector('input[name=redirect]');
        var product = this.form.querySelector('input[name=product]');
        var title = this.form.querySelector('select[name=title]');
        var titleOther = form.querySelector('input[name=other-title]');
        var firstName = form.querySelector('input[name=first-name]');
        var surname = form.querySelector('input[name=surname');
        var telephone = form.querySelector('input[name=telephone-number');
        var emailAddress = form.querySelector('input[name=emailAddress');
        var comments = form.querySelector('textarea[name=comments');
        var pageUrl = window.location.href;
        var postData = '';
        if (this.formValueFeedbackType) {
            postData += 'feedbackType=' + this.formValueFeedbackType + '&';
        }
        if (recipient) {
            postData += 'recipient=' + recipient.value + '&';
        }
        if (email) {
            postData += 'email=' + email.value + '&';
        }
        if (subject) {
            postData += 'subject=' + subject.value + '&';
        }
        if (redirect) {
            postData += 'redirect=' + redirect.value + '&';
        }
        if (product) {
            postData += 'productName=' + product.value + '&';
        }
        if (title) {
            if (titleOther) {
                postData += 'title=' + titleOther.value + '&';
            }
            else {
                postData += 'title=' + title.value + '&';
            }
        }
        if (firstName) {
            postData += 'firstName=' + firstName.value + '&';
        }
        if (surname) {
            postData += 'surname=' + surname.value + '&';
        }
        if (telephone) {
            postData += 'tel=' + telephone.value + '&';
        }
        if (emailAddress) {
            postData += 'emailAddress=' + emailAddress.value + '&';
        }
        if (comments) {
            postData += 'comments=' + comments.value + '&';
        }
        // if (this.callmebackFormId) {
        // 	postData += 'callmebackFormId=' + this.callmebackFormId + '&';
        // }
        if (pageUrl) {
            postData += 'pageUrl=' + pageUrl + '&';
        }
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitGenericForm.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        });
    };
    FormItemGenericForm.prototype.actionFormNew = function (form) {
        // fields
        var fieldsInputs = Array.from(form.querySelectorAll('input, select, textarea'));
        var loader = form.querySelector('.form__loader--container');
        var thankyou = form.querySelector('.form__thankyou--container');
        var postData = '';
        var fields = [];
        fieldsInputs.map(function (field) {
            var getName = field.getAttribute('name');
            var getType = field.getAttribute('type');
            var getValue = field.value;
            getName = getName.replace(' ', '_');
            if (fields[getName]) {
                var currentValue = fields[getName].value;
                if (getType === 'checkbox') {
                    if (field.checked) {
                        currentValue += ',' + field.value;
                    }
                }
                else if (getType === 'radio') {
                }
                else {
                    currentValue += ',' + field.value;
                }
                fields[getName].value = currentValue;
            }
            else {
                if (getType === 'radio') {
                    var radioButtons = Array.from(form.querySelectorAll("input[name='" + getName + "']"));
                    radioButtons.map(function (button) {
                        if (button.checked) {
                            getValue = button.value;
                        }
                    });
                }
                fields[getName] = {
                    name: getName,
                    value: getValue
                };
            }
        });
        var objectKeys = Object.keys(fields);
        objectKeys.forEach(function (key) {
            postData += key + '=' + fields[key].value + '&';
        });
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitGenericForm.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        });
    };
    FormItemGenericForm.prototype.actionFormRecaptcha = function (form) {
        // fields
        var fieldsInputs = Array.from(form.querySelectorAll('input, select, textarea'));
        var loader = form.querySelector('.form__loader--container');
        var thankyou = form.querySelector('.form__thankyou--container');
        var postData = '';
        var fields = [];
        fieldsInputs.map(function (field) {
            var getName = field.getAttribute('name');
            var getType = field.getAttribute('type');
            var getValue = field.value;
            getName = getName.replace(' ', '_');
            if (fields[getName]) {
                var currentValue = fields[getName].value;
                if (getType === 'checkbox') {
                    if (field.checked) {
                        currentValue += ',' + field.value;
                    }
                }
                else if (getType === 'radio') {
                }
                else {
                    currentValue += ',' + field.value;
                }
                fields[getName].value = currentValue;
            }
            else {
                if (getType === 'radio') {
                    var radioButtons = Array.from(form.querySelectorAll("input[name='" + getName + "']"));
                    radioButtons.map(function (button) {
                        if (button.checked) {
                            getValue = button.value;
                        }
                    });
                }
                fields[getName] = {
                    name: getName,
                    value: getValue
                };
            }
        });
        var objectKeys = Object.keys(fields);
        objectKeys.forEach(function (key) {
            postData += key + '=' + fields[key].value + '&';
        });
        var gRecaptcha = form.querySelector('.g-recaptcha');
        var siteKey = gRecaptcha.getAttribute('data-sitekey');
        postData += 'siteKey=' + siteKey + '&';
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitGenericFormV2.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        });
    };
    return FormItemGenericForm;
}(Base));
export { FormItemGenericForm };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-generic-form/form-item-generic-form.component.ts
// module id = 904
// module chunks = 0